<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="提现列表" name="cashrewords">
        <cashrewords v-if="activeName=='cashrewords'"></cashrewords>
      </el-tab-pane>
      <el-tab-pane label="待定" name="report">
        <Report v-if="activeName=='report'"></Report>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import bus from "@/utils/eventBus.js";
import cashrewords from "./cashrewords/index";
// import Report from "./report/index";
export default {
  components: {
    cashrewords
    // Report
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前选中*/
      activeName: "cashrewords"
    };
  },
  methods: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/channel/category/index.vue